import { registerDefaults } from "./defaults";
import { type Store, type WebWidgetsWindow, registerModules } from "./services/modules";
import { loadRecordCache, saveRecordCache } from "./stores/cache";
import { Deferred } from "./util/deferred";
import "./styles/normalize.scss";
import "./styles/app.css";

const WINDOW = window as unknown as WebWidgetsWindow;
const READY = new Deferred<Store>();

// Register the ready task
if (WINDOW.YaaWebWidgets) {
	console.warn("YaaWebWidgets is already defined on the window object. Duplicate modules may be loaded.");
}

// Define global API
WINDOW.YaaWebWidgets = {
	_modules: READY.then((store) => store.modules),
	_widgets: READY.then((store) => store.widgets),
	async mount(id, config) {
		return READY.then((store) => {
			const handle = store.widgets[id];
			const module = store.index[id];

			if (!handle || !module) {
				throw new Error(`Widget ${id} is not available.`);
			}

			// load the record cache
			loadRecordCache();

			const ctx = Object.assign({ parent: document }, module.config, config);
			return handle.onMount(ctx);
		});
	},
	overrideStyle(style) {
		sessionStorage.setItem("yaa-web-widgets:style", style);
	},
};

// Apply default configuration
registerDefaults();

// Initialize available modules
registerModules(import.meta.glob("../modules/*/index.tsx")).then((store) => {
	READY.resolve(store);
});

// Sync record cache with local storage
window.addEventListener("beforeunload", () => {
	saveRecordCache();
});
